import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { OrgUnitSelector } from '@shared/components/inputs/OrgUnitSelector';

/**
 * @typedef {object} FormOrgUnitSelectorOwnProps
 * @property {string} name
 */

/**
 * @typedef {FormOrgUnitSelectorOwnProps &
 *   React.ComponentPropsWithoutRef<typeof OrgUnitSelector>} FormOrgUnitSelectorProps
 */

/**
 * @param {FormOrgUnitSelectorProps} props
 */
const FormOrgUnitSelector = props => {
  const { name, ...otherProps } = props;

  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <OrgUnitSelector {...field} hasError={!!errors[name]} {...otherProps} />
      )}
    />
  );
};

export default FormOrgUnitSelector;
